import { Buffer } from "buffer";

// gray-matter (used client-side via src/utils/content.js) expects Node's
// Buffer global, which doesn't exist in the browser — without this the
// entire app crashes silently on every markdown-driven page.
globalThis.Buffer = globalThis.Buffer || Buffer;
